// extracted by mini-css-extract-plugin
module.exports = {"Results":"SearchPanel_Results__xPnMN"};